const state = {
  contact: {},
};

export { state };
